import { render, staticRenderFns } from "./FloatContactS.vue?vue&type=template&id=babef810&scoped=true"
import script from "./FloatContactS.vue?vue&type=script&lang=js"
export * from "./FloatContactS.vue?vue&type=script&lang=js"
import style0 from "./FloatContactS.vue?vue&type=style&index=0&id=babef810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babef810",
  null
  
)

export default component.exports